export const config = {
  title: "Sago's Painting & Remodeling | TN 37330",
  meta: {
    description:
      "Sago's Painting & Remodeling offers professional interior and exterior painting, drywall, flooring, and remodeling services throughout TN 37330 and surrounding areas.",
    keywords: [
      "painting TN 37330",
      "remodeling TN",
      "drywall services",
      "flooring contractor",
      "Sago's Painting and Remodeling"
    ],
    author: "Sago's Painting & Remodeling",
    canonicalUrl: "https://sagospaintingandremodeling.com/",
  },
  sections: {
    header: {
      businessName: "Sago's Painting & Remodeling",
    },
    sectionB: {
      heroTitle: "Sago's Painting & Remodeling",
      heroSubtitle: "Transforming Homes with Precision & Quality in TN",
      learnAboutText: "Request a Quote",
      phoneNumber: "9313083088",
      phoneLabel: "(931) 308-3088",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2190057704/photo/man-painting-living-room-wall-during-apartment-renovation.jpg?s=612x612&w=0&k=20&c=YdjDxlzP_PRNjX_yERTALgepZALghon-9H4PUF52ygw=",
      cardData: [
        {
          title: "Interior & Exterior Painting",
          description:
            "Refresh and modernize your home with expert painting services.",
        },
        {
          title: "Drywall & Flooring",
          description:
            "Smooth drywall finish and precise flooring installation done right.",
        },
        {
          title: "Home Remodeling",
          description:
            "Turn your ideas into reality with custom remodeling solutions.",
        },
      ],
      description:
        "Locally trusted in TN 37330, Sago's Painting & Remodeling provides top-tier painting, flooring, drywall, and home renovation services. Let us enhance your home with quality you can see.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "From painting and drywall to full remodeling projects, we’re your reliable partner for home transformations.",
      cards: [
        {
          title: "Interior Painting",
          description:
            "We bring life to your rooms with high-quality, clean, and vibrant finishes.",
          imageSrc: "https://media.istockphoto.com/id/1461683093/photo/man-painting-wall-with-light-blue-dye-indoors-back-view.jpg?s=612x612&w=0&k=20&c=TDg87xVDJh-VA4zVClGlMnqpdqTh2QcZ--raihCv9XU=",
          imageAlt: "Interior Painting",
        },
        {
          title: "Drywall Repair & Installation",
          description:
            "Expert drywall services ensuring smooth surfaces and perfect preparation.",
          imageSrc: "https://media.istockphoto.com/id/1334476404/photo/interior-decoration-construction-furniture-builtin.jpg?s=612x612&w=0&k=20&c=7dO5gvJmaRyDHE1oqmLqRtPUf7S8pExjIL8ImdTxqS8=",
          imageAlt: "Drywall Repair",
        },
        {
          title: "Custom Remodeling",
          description:
            "Kitchen, bathroom, and general home remodels tailored to your vision.",
          imageSrc: "https://media.istockphoto.com/id/2190545959/photo/drywall-installers-working-in-kitchen-renovation.jpg?s=612x612&w=0&k=20&c=8KvK4Q7uZUewEINYzC7JmvpgsXxX1QkkCu7ZxinNFTs=",
          imageAlt: "Remodeling Services",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Locally Owned & Operated",
        "High Quality Craftsmanship",
        "Free Estimates",
        "Timely Project Completion",
        "Satisfaction Guaranteed"
      ],
    },
    sectionD: {
      aboutTitle: "About Sago's Painting & Remodeling",
      aboutImage: {
        src: "https://sagospaintingandremodeling.com/wp-content/uploads/2025/08/image17-e1754502037898.webp",
        alt: "Sago's Painting & Remodeling Team",
      },
      aboutText: [
        "Sago's Painting & Remodeling is a Tennessee-based company offering a wide range of home improvement services.",
        "Our mission is to deliver high-quality craftsmanship at an affordable price. We treat every home like it's our own.",
      ],
    },
    sectionE: {
      profileImage: "https://sagospaintingandremodeling.com/wp-content/uploads/2023/08/SagoPainting__Remodeling_-02-01-1-scaled-e1754590574186.png",
      profileAlt: "Sago's Painting & Remodeling Logo",
      businessName: "Sago's Painting & Remodeling",
      contact: {
        phone: "9313083088",
        phoneLabel: "(931) 308-3088",
        email: "joshuasago52@gmail.com",
        website: "https://sagospaintingandremodeling.com/",
        address: "Tennessee 37330, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Tennessee 37330, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3315.0000000!2d-86.0000000!3d35.2750000!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x886349d40123abcd%3A0xabc1234567890def!2sTN%2037330!5e0!3m2!1sen!2sus!4v1710000000000",
    },
  },
};

export default config;
